/**
 * 素材统计页 API
 * 对应板块: 板块 B、C、D、E、F
 */
import http from './utils';
import { prefix } from './constants';

/**
 * 素材统计 - 板块 B 指标卡片
 * POST ${prefix}/ad_creative/stats
 */
export function getAdCreativeStats(payload: any) {
  return http({
    url: `${prefix}/ad_creative/stats`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
}

/**
 * 时间线趋势 - 板块 C、D、E、F
 * POST ${prefix}/ad_creative/timeline
 *
 * 子板块 metric 参数:
 * - 板块 C: creatives_trend
 * - 板块 D-1: creative_count_stat, platform_percent_stat
 * - 板块 D-2: creative_score_stat, impression_stat
 * - 板块 E: country_stat
 * - 板块 F-1: creative_type_stat
 * - 板块 F-2: engagement_stat
 */
export function getAdCreativeTimeline(payload: any) {
  return http({
    url: `${prefix}/ad_creative/timeline`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
}

/**
 * 维度值查询 - 板块 E 国家分布
 * POST ${prefix}/ad_creative/dimension_values
 *
 * 返回指定 metric 的维度值列表（含数值，按 value 降序）
 * 目前仅支持 country_stat
 */
export function getAdCreativeDimensionValues(payload: any) {
  return http({
    url: `${prefix}/ad_creative/dimension_values`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
}

/**
 * Marketing 筛选条件 - 获取素材国家/渠道等配置
 * POST /api/v1/marketing/filter/cond
 */
export function getMarketingFilterCond(payload: any) {
  return http({
    url: '/api/v1/marketing/filter/cond',
    method: 'post',
    data: payload,
  }) as Promise<any>;
}
